import { render } from "./BendingShear.vue?vue&type=template&id=7bdfa2f9"
import script from "./BendingShear.vue?vue&type=script&lang=js"
export * from "./BendingShear.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__